// extracted by mini-css-extract-plugin
export default {"root":"JbT8d0t8","right":"_3fbTNNoe"};